<template>
  <!-- Use runtime-bound src to avoid Vite pre-resolving this as a module import -->
  <img
    :src="logoPath"
    alt="Nayatel"
    class="cw-brand-logo"
    decoding="async"
    width="160"
    height="40"
  />
</template>

<script setup>
// point to the thumbnail JPG in public/brand-assets
const logoPath = '/brand-assets/logo_thumbnail.jpg'
</script>

<style scoped>
.cw-brand-logo {
  display: inline-block;
  max-width: 200px;
  height: auto;
  object-fit: contain;
  vertical-align: middle;
}
</style>
